import React, { Component } from 'react';
import { connect } from 'react-redux';

import NoData from '../../../components/NoData/NoData';
import CardPlaceholder from '../../../components/CardPlaceholder';
import { DatePicker, Options } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';
import CTADetailsAccordion from '../../../components/DetailsAccordion/CTADetailsAccordion';
import CTAChart from './CTAChart';
import WipAvgAge from './WipAvgAge';
import DailyWIP from './DailyWIP';
import chartUtils from '../../../util/chartUtils';

import { constant } from 'async';

class WallboardCTAChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {},
      data: {
        series: [],
        categories: [],
        healthZones: []
      }
    };
  }

  componentDidMount() {
    if (this.props.data) {
      this.setDataPoint();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setDataPoint();
    }
  }

  setDataPoint(day = -1) {
    const data = this.props.data[0];

    if (data) {
      this.setState({
        selectedPoint: {},
        data
      });
    }
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });
  };

  render() {
    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <div className='title-info'>
            <p>Aging Chart</p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          <div className="button_tools">
            <Options
              chart="cta"
              showAvgChart
              showLineChart
              options={{
                avgChartTooltip: 'WIP average age',
                lineChartTooltip: 'WIP'
              }}
            />
            <DatePicker />
          </div>
        </div>
        <div className="dashboard_details">
          {this.props.lineChart && (this.state.data && chartUtils.hasWorkItems(this.props.data) ? (
            <DailyWIP day={this.props.dates.daysFromStart} data={this.props.data} dayData={this.state.data} dateFormat={this.props.dateFormat} />
          ) : (
            <CardPlaceholder title={this.props.wipBreakdownType === 'pie' ? 'WIP breakdown' : 'WIP'} shape={this.props.wipBreakdownType === 'pie' ? 'pie' : 'line'} loading={this.props.isLoading} />
          ))}
          {this.props.avgChart && (this.state.data && chartUtils.hasWorkItems(this.props.data) ? (
            <WipAvgAge day={this.props.dates.daysFromStart} data={this.props.data} />
          ) : (
            <CardPlaceholder title="WIP average age" shape="line" loading={this.props.isLoading} />
          ))}
        </div>
        <div className="chart_row">
          <div className="diagram_details">
            <CTAChart id="CTA" data={this.state.data} onPointClick={this.handlePointClick} />
            <NoData show={this.state.data.series && !this.state.data.series.length} loading={this.props.isLoading} />
          </div>
          <CTADetailsAccordion id="details-accordion" data={this.state.selectedPoint} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dateFormat: state.filters.dateFormat,
    dates: state.filters.dates,
    avgChart: state.filters.cta.avgChart,
    lineChart: state.filters.cta.lineChart,
    wipBreakdownType: state.filters.cta.wipBreakdownType,
    data: state.cta.data,
    isLoading: state.cta.isLoading,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps)(WallboardCTAChart);
